import React from 'react';
import { WebSessionContextProvider } from '@switch/core';
import { useWidgetContext } from "./widgetContext";
import { useSearchParams } from 'react-router-dom';

export const WidgetSession = (props) => {
    const { children } = props;
    const { api, isAWidget } = useWidgetContext();

    const source = isAWidget ? "widgetV1" : undefined;
    const searchParams = new URLSearchParams(window.location.search);
    const sessionKey = searchParams.get("sessionKey")

    if (!isAWidget) return;(<div></div>)

    return (
        <WebSessionContextProvider source={source} dataProvider={api} sessionKey={sessionKey}>
            {children}
        </WebSessionContextProvider>
    );
}
